import { render, staticRenderFns } from "./SeasonRlrRatingChip.vue?vue&type=template&id=330c818e&scoped=true&"
import script from "./SeasonRlrRatingChip.vue?vue&type=script&lang=js&"
export * from "./SeasonRlrRatingChip.vue?vue&type=script&lang=js&"
import style0 from "./SeasonRlrRatingChip.vue?vue&type=style&index=0&id=330c818e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330c818e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})
